// src/components/Atelier 2/Activite1/GuideModal.js
import React from 'react';
import { motion } from 'framer-motion';
import { MousePointer, Edit, Save, AlertCircle, Target, Activity, Database, X, HelpCircle } from 'lucide-react';

const GuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const steps = [
    {
      title: "Sélectionner les catégories",
      description: "Sélectionnez les catégories de menaces pertinentes pour votre organisation en cliquant sur les cartes.",
      icon: <MousePointer size={20} className="text-blue-500" />
    },
    {
      title: "Ajouter des sources de risque",
      description: "Pour chaque catégorie sélectionnée, ajoutez des sources de risque spécifiques en utilisant le formulaire à gauche.",
      icon: <AlertCircle size={20} className="text-purple-500" />
    },
    {
      title: "Compléter les détails",
      description: "Complétez les détails de chaque source (nom, objectif visé, motivation, activité, ressources).",
      icon: <Target size={20} className="text-orange-500" />
    },
    {
      title: "Gérer les sources",
      description: "Vous pouvez modifier ou supprimer les sources ajoutées via les boutons d'action.",
      icon: <Edit size={20} className="text-green-500" />
    },
    {
      title: "Enregistrer vos modifications",
      description: "N'oubliez pas d'enregistrer vos modifications avant de quitter la page.",
      icon: <Save size={20} className="text-red-500" />
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden mb-6"
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 flex justify-between items-center">
        <div className="flex items-center">
          <HelpCircle size={24} className="text-white mr-3" />
          <h2 className="text-xl font-bold text-white">Guide d'identification des SR et OV</h2>
        </div>
        <button
          onClick={onClose}
          className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-1 transition-colors duration-200"
          aria-label="Fermer le guide"
        >
          <X size={24} />
        </button>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="space-y-6">
      {steps.map((step, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="flex"
        >
          <div className="flex-shrink-0 mr-4">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600 font-bold">
              {index + 1}
            </div>
          </div>
          <div className="flex-1">
            <div className="flex items-center mb-2">
              {step.icon}
              <h3 className="text-lg font-semibold text-gray-800 ml-2">{step.title}</h3>
            </div>
            <p className="text-gray-600">{step.description}</p>
          </div>
        </motion.div>
      ))}

      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md mt-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <Activity className="h-5 w-5 text-blue-500" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">Conseil</h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                Survolez les cartes de catégories pendant quelques secondes pour voir plus de détails sur chaque type de menace.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4 border-t border-gray-200">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-colors duration-200 mr-2"
        >
          Fermer
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-200 flex items-center"
        >
          <Database size={16} className="mr-2" />
          Commencer
        </button>
      </div>
        </div>
      </div>
    </motion.div>
  );
};

export default GuideModal;